import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../dynamicFormBuilder/FormField'
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { FMDefaultsLayout } from "../../common/Layouts";
let transportCarrier = null;
function FMDefaultsTab(props) {
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    transportCarrier = props.formFields.R_TRANSPORTCARRIER;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const onFormLoad = useCallback(() => {
        props.fmDefaultsFormLookupsLoad(formRefs);
    });
  const handleFieldChange = useCallback((name, value) => {
    });
    const handleSelectionChange = useCallback((name, e) => {
    }, []);
    return (
        <div className="FormMt">
            <FormField
            currrentUser={currentUser}
            layoutId='A7D1C453-A541-4735-8B23-BF4AA5ABF1C0'
            layoutName='FMDefaultForm'
            defaultFormSchema={FMDefaultsLayout}
            formFields={props.formFields}
            setformFields={props.setformFields}
            onFormLoad={onFormLoad}
            handleFieldValueChange={handleFieldChange}
            handleSelectedItemChange={handleSelectionChange}
            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
            formRefs={formRefs}
        />
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(FMDefaultsTab);